import BannerHero from "@/components/bannerHero";
import TestimonialsSection from "@/components/testimonials/TestimonialsSection";
import UnderConstruction from "@/components/UnderConstruction";

export default function About() {
  return (
    <>
     <BannerHero
                title="Testimonials"
                bgImage="/images/testimonials.png" 
                className="testimonials"/>
       
          <UnderConstruction />

       {/* <TestimonialsSection /> */}
  
      
    </>
  );
}